import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import routes from "./routes";
import { useFormik } from "formik";
import PrimaryNav from "./components/PrimaryNav";

const Body = props => (
  <Sentry.ErrorBoundary
    fallback={createModuleErrorBoundary("exhibition")}
    beforeCapture={scope => {
      scope.setTag("module", "exhibition");
    }}
  >
    <RouterRoutes>
      {routes?.map((item, index) => {
        return (
          <Route
            key={index}
            path={item?.path}
            element={
              <AuthRoute permissions={item.permissions}>
                <item.element {...props} />
              </AuthRoute>
            }
          />
        );
      })}
    </RouterRoutes>
  </Sentry.ErrorBoundary>
);

const Exhibition = props => {
  const formik = useFormik({
    initialValues: {},
  });
  return (
    <>
      <PrimaryNav formik={formik} />
      <Body {...props} formik={formik} />
    </>
  );
};

export default Exhibition;
